import { classNames } from 'primereact/utils';

interface SummaryCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  bgClass?: string;
  textClass?: string;
  iconColor?: string;
  iconBgStyle?: string;
  onClick?: () => void;
  trend?: 'up' | 'down' | 'neutral';
  compact?: boolean;
}

const SummaryCard = (props: SummaryCardProps): JSX.Element => {
  const { title, value, subtitle, icon, bgClass, textClass, iconColor, iconBgStyle, onClick, compact } = props;

  if (compact) {
    return (
      <div
        className={classNames(
          'rounded-xl px-4 py-3 bg-white border border-gray-100 shadow-sm',
          bgClass,
          { 'hover:shadow-md hover:cursor-pointer transition-all duration-200': !!onClick }
        )}
        onClick={onClick}
      >
        <div className="flex items-center gap-3">
          {icon && (
            <div className={classNames('rounded-lg flex items-center justify-center text-white text-sm flex-shrink-0', !iconBgStyle && (iconColor || 'bg-[#2571ab]'))} style={{ width: '36px', height: '36px', ...(iconBgStyle ? { background: iconBgStyle } : {}) }}>
              <i className={icon} />
            </div>
          )}
          <div className="min-w-0">
            <div className={classNames('text-[0.65rem] font-semibold text-gray-400 uppercase tracking-wide whitespace-nowrap', textClass)}>{title}</div>
            <div className="text-lg font-bold text-gray-800 leading-tight">{value}</div>
          </div>
        </div>
        {subtitle && <div className="text-[0.7rem] text-gray-400 mt-1.5 pl-12">{subtitle}</div>}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'rounded-xl px-5 py-4 bg-white border border-gray-100 shadow-sm',
        bgClass,
        { 'hover:shadow-md hover:cursor-pointer transition-all duration-200': !!onClick }
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <div className={classNames('text-[0.7rem] font-semibold text-gray-400 uppercase tracking-wide', textClass)}>{title}</div>
          <div className="text-2xl font-bold text-gray-800 mt-1">{value}</div>
          {subtitle && <div className="text-[0.75rem] text-gray-400 mt-1">{subtitle}</div>}
        </div>
        {icon && (
          <div className={classNames('rounded-xl flex items-center justify-center text-white text-lg flex-shrink-0', !iconBgStyle && (iconColor || 'bg-[#2571ab]'))} style={{ width: '44px', height: '44px', ...(iconBgStyle ? { background: iconBgStyle } : {}) }}>
            <i className={icon} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SummaryCard;
